'use client';
import React from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { PaginationBar as SharedPaginationBar } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';

const SharedRender = (SharedPaginationBar as any).render;
const SharedComp: React.FC<any> = (props) => <SharedRender {...props} />;

function PaginationBarImpl(rawProps: any) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const puckContext = usePuckContext() as any;
  const context = puckContext?.context || puckContext;

  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  const perPage = parseInt(searchParams.get('perPage') || '12', 10);

  // Compute totalPages from totalCount in context
  const totalCount = context?.totalCount || 0;
  const totalPages = Math.max(1, Math.ceil(totalCount / perPage));

  const handlePageChange = (page: number) => {
    const params = new URLSearchParams(searchParams.toString());
    if (page === 1) { params.delete('page'); } else { params.set('page', String(page)); }
    const qs = params.toString();
    router.push(qs ? `${pathname}?${qs}` : pathname);
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePerPageChange = (n: number) => {
    const params = new URLSearchParams(searchParams.toString());
    if (n === 12) { params.delete('perPage'); } else { params.set('perPage', String(n)); }
    params.delete('page'); // reset to page 1 on perPage change
    const qs = params.toString();
    router.push(qs ? `${pathname}?${qs}` : pathname);
  };

  return (
    <SharedComp
      {...rawProps}
      currentPage={currentPage}
      totalPages={totalPages}
      totalCount={totalCount}
      perPage={perPage}
      onPageChange={handlePageChange}
      onPerPageChange={handlePerPageChange}
    />
  );
}

export const PaginationBar: any = {
  ...SharedPaginationBar,
  render: (props: any) => <PaginationBarImpl {...props} />,
};
export default PaginationBar;
